"use strict";
// @ts-ignore
try {
    self['workbox:core:5.0.0'] && _();
}
catch (e) { }
